(function () {
  /* Hover/touch-intent prefetching. The view transition crossfade can only
     start once the new document is ready to paint — it can't hide network
     latency, only what happens after. This cuts that latency instead: by
     the time a click actually lands, the response is very often already
     in the HTTP cache from the moment the cursor arrived (or a finger
     touched down), so navigation itself is what feels faster, not just
     the animation covering for it. */

  var connection = navigator.connection;
  if (connection && (connection.saveData || /2g/.test(connection.effectiveType || ''))) return;

  var HOVER_DELAY_MS = 90;
  var prefetched = new Set();
  var hoverTimer = null;

  var SAFE_PATH = /^\/(products|collections|pages|blogs)\//;

  function isSafeToPrefetch(link) {
    if (!(link instanceof HTMLAnchorElement) || !link.href) return false;
    if (link.origin !== window.location.origin) return false;
    if (link.hasAttribute('download') || link.target === '_blank') return false;
    if (link.hasAttribute('data-no-prefetch')) return false;
    if (link.search || link.hash) return false;
    if (link.pathname === window.location.pathname) return false;
    return SAFE_PATH.test(link.pathname) || link.pathname === '/';
  }

  function prefetch(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  }

  function onPointerOver(event) {
    var link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !isSafeToPrefetch(link)) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      prefetch(link.href);
    }, HOVER_DELAY_MS);
  }

  function onPointerOut(event) {
    var link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link) clearTimeout(hoverTimer);
  }

  function onTouchStart(event) {
    var link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link && isSafeToPrefetch(link)) prefetch(link.href);
  }

  document.addEventListener('pointerover', onPointerOver, { passive: true });
  document.addEventListener('pointerout', onPointerOut, { passive: true });
  document.addEventListener('touchstart', onTouchStart, { passive: true });
})();
